<div class="modal-header">
  <h5 class="modal-title">{{ author.id ? 'Chỉnh sửa tác giả' : 'Thêm tác giả' }}</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <!-- Author Name Field -->
    <div class="form-group">
      <label for="name" id="name_display_as_box">
        Tên
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Nhập tên đầy đủ của tác giả."></i>
      </label>
      <input
        id="name"
        name="name"
        class="form-control"
        type="text"
        placeholder="ví dụ: Nguyễn Nhật Ánh"
        [(ngModel)]="author.name"
      />
    </div>

    <!-- Note Field -->
    <div class="form-group">
      <label for="note" id="note_display_as_box">
        Ghi chú
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Ghi chú thêm về tác giả."></i>
      </label>
      <input
        id="note"
        name="note"
        class="form-control"
        type="text"
        placeholder="ví dụ: Nhà văn nổi tiếng"
        [(ngModel)]="author.note"
      />
    </div>

    <!-- Date of Birth Field -->
    <div class="form-group">
      <label for="dateOfBirth" id="dateOfBirth_display_as_box">
        Ngày sinh
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Nhập ngày sinh của tác giả."></i>
      </label>
      <input
        id="dateOfBirth"
        name="dateOfBirth"
        class="form-control"
        type="date"
        [(ngModel)]="author.dateOfBirth"
      />
    </div>

    <!-- Died Field -->
    <div class="form-group">
      <label for="died" id="died_display_as_box">
        Đã mất
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Chọn nếu tác giả đã qua đời."></i>
      </label>
      <input
        id="died"
        name="died"
        class="form-check-input"
        type="checkbox"
        [(ngModel)]="author.died"
        (change)="onDiedChange()"
      />
    </div>

    <!-- Date of Death Field -->
    <div class="form-group" *ngIf="author.died">
      <label for="dateOfDeath" id="dateOfDeath_display_as_box">
        Ngày mất
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Nhập ngày mất của tác giả."></i>
      </label>
      <input
        id="dateOfDeath"
        name="dateOfDeath"
        class="form-control"
        type="date"
        [(ngModel)]="author.dateOfDeath"
      />
    </div>

    <!-- Bio Field -->
    <div class="form-group">
      <label for="bio" id="bio_display_as_box">
        Tiểu sử
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Nhập tiểu sử ngắn của tác giả."></i>
      </label>
      <textarea
        id="bio"
        name="bio"
        class="form-control"
        rows="3"
        placeholder="ví dụ: Nguyễn Nhật Ánh là một nhà văn nổi tiếng..."
        [(ngModel)]="author.bio"
      ></textarea>
    </div>

    <!-- Publications Field -->
    <div class="form-group">
      <label for="publications" id="publications_display_as_box">
        Ấn phẩm
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Danh sách các ấn phẩm của tác giả."></i>
      </label>
      <textarea
        id="publications"
        name="publications"
        class="form-control"
        rows="3"
        placeholder="ví dụ: Sách 1, Sách 2"
        [(ngModel)]="author.publications"
      ></textarea>
    </div>

    <!-- Awards Field -->
    <div class="form-group">
      <label for="awards" id="awards_display_as_box">
        Giải thưởng
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Danh sách các giải thưởng mà tác giả đã nhận được."></i>
      </label>
      <textarea
        id="awards"
        name="awards"
        class="form-control"
        rows="3"
        placeholder="ví dụ: Giải thưởng Pulitzer"
        [(ngModel)]="author.award"
      ></textarea>
    </div>

    <!-- References Field -->
    <div class="form-group">
      <label for="references" id="references_display_as_box">
        Tham khảo
        <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="Mô tả: Danh sách các tham khảo về tác giả."></i>
      </label>
      <textarea
        id="references"
        name="references"
        class="form-control"
        rows="3"
        placeholder="ví dụ: Trang web của tác giả, Wikipedia"
        [(ngModel)]="author.references"
      ></textarea>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">
    {{ writerI18n?.cancelButtonI18n || 'Hủy' }}
  </button>
  <button type="button" class="btn btn-outline-primary" (click)="saveAuthor()">
    {{ writerI18n?.saveButtonI18n || 'Lưu' }}
  </button>
</div>
